"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TabListRoot = void 0;

var tslib_1 = require("tslib");

var ui_helper_props_to_styles_1 = require("@hopin-team/ui-helper-props-to-styles");

var ui_symbols_1 = require("@hopin-team/ui-symbols");

var tabs_1 = require("@reach/tabs");

var styled_components_1 = tslib_1.__importStar(require("styled-components"));

var slider_1 = require("./slider");

var tab_1 = require("./tab");

var patternStyles = {
  aside: styled_components_1.css(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n    margin-top: 0.25rem;\n  "], ["\n    margin-top: 0.25rem;\n  "]))),
  nested: styled_components_1.css(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n    margin-top: 0;\n    grid-column-gap: 1.5rem;\n  "], ["\n    margin-top: 0;\n    grid-column-gap: 1.5rem;\n  "]))),
  main: styled_components_1.css(templateObject_3 || (templateObject_3 = tslib_1.__makeTemplateObject(["\n    margin-bottom: 0.125rem;\n  "], ["\n    margin-bottom: 0.125rem;\n  "]))),
  schedule: styled_components_1.css(templateObject_4 || (templateObject_4 = tslib_1.__makeTemplateObject(["\n    display: inline-grid;\n    grid-column-gap: 1.5rem;\n    height: auto;\n    overflow: scroll;\n\n    &::webkit-scrollbar {\n      display: none;\n    }\n\n    -ms-overflow-style: none;\n    scrollbar-width: none;\n  "], ["\n    display: inline-grid;\n    grid-column-gap: 1.5rem;\n    height: auto;\n    overflow: scroll;\n\n    &::webkit-scrollbar {\n      display: none;\n    }\n\n    -ms-overflow-style: none;\n    scrollbar-width: none;\n  "])))
};
exports.TabListRoot = styled_components_1.default(tabs_1.TabList)(templateObject_5 || (templateObject_5 = tslib_1.__makeTemplateObject(["\n  position: relative;\n  width: 100%;\n  height: ", ";\n  display: grid;\n  background: none;\n\n  & > ", "[data-focus-visible-added] ~ ", " {\n    opacity: 0;\n  }\n\n  ", "\n  grid-template-columns: repeat(", ", minmax(", ", 1fr));\n"], ["\n  position: relative;\n  width: 100%;\n  height: ", ";\n  display: grid;\n  background: none;\n\n  & > ", "[data-focus-visible-added] ~ ", " {\n    opacity: 0;\n  }\n\n  ", "\n  grid-template-columns: repeat(", ", minmax(", ", 1fr));\n"])), function (_a) {
  var _b;

  var theme = _a.theme;
  return ui_symbols_1.calcSpace(6, (_b = theme === null || theme === void 0 ? void 0 : theme.SCALE) === null || _b === void 0 ? void 0 : _b.STEP);
}, tab_1.Tab, slider_1.Slider, function (props) {
  return ui_helper_props_to_styles_1.mapStyles(props, 'pattern', patternStyles);
}, function (_a) {
  var count = _a.count;
  return count;
}, function (_a) {
  var pattern = _a.pattern;
  return pattern === 'schedule' ? 'auto' : '5rem';
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;